import { Container, Typography } from '@pwskills/rachnaui';
import Slider from '@pwskills/rachnaui/components/Slider';
import React, { useContext } from 'react';
import Headers from '@/components/common/Header';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { useRouter } from 'next/router';
import MentorCompanyCard from './MentorCompanyCard';

const MentorCompanySection = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { mentorsCompanies } = courseDetails?.courseMetaDetails || {};
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const returnChildren = () => {
    return (
      <div className="py-8 large:!py-14 flex flex-col  medium:gap-8 large:gap-14">
        {isDashboard ? (
          <Typography component="h4" variant="semi-bold">
            Get Mentored by Experts From
          </Typography>
        ) : (
          <Headers
            title="Get Mentored by Experts From"
            classes="flex justify-center text-gray-850 !min-w-full"
          />
        )}
        <Slider
          className="[&>*]:w-full gap-5 my-[30px] !pt-0 "
          iconWrapperClass=""
          autoPlay
          positionOfSliderInMobile="bottom"
        >
          {mentorsCompanies?.map((company) => (
            <MentorCompanyCard company={company} key={company._id} />
          ))}
        </Slider>
      </div>
    );
  };
  if (mentorsCompanies && mentorsCompanies?.length > 0) {
    if (isDashboard) {
      return returnChildren();
    }
    return (
      <div className="bg-gradient-to-b  from-white to-[#FFFAF9]">
        <Container>{returnChildren()}</Container>
      </div>
    );
  }
  return null;
};

export default MentorCompanySection;
